import { cn } from '@/lib/infra/utils';
import type { FeeDisplayStatus } from '@/services/hydraFees';

export const FEE_DISPLAY_MESSAGE: Record<FeeDisplayStatus, string | null> = {
  'not-applicable': null,
  loading: 'Fee schedule is still loading; showing the raw venue price.',
  missing: 'Fee schedule unavailable; showing the raw venue price.',
  unsupported: 'This fee schedule cannot be adjusted on this surface; showing the raw venue price.',
  estimated: 'Fee schedule is temporarily estimated conservatively.',
  exact: null,
};

/** Missing/unsupported states are the only ones the opt-in hide control suppresses. */
export function feeDisplayCanHide(status: FeeDisplayStatus): boolean {
  return status === 'missing' || status === 'unsupported';
}

export function FeeScheduleMarker({
  status,
  className,
}: {
  status: FeeDisplayStatus;
  className?: string;
}) {
  const message = FEE_DISPLAY_MESSAGE[status];
  // Loading is transient and already renders raw. Do not flash a warning into
  // every row during ordinary application startup.
  if (!message || status === 'loading') return null;

  const estimated = status === 'estimated';
  return (
    <span
      data-testid="fee-schedule-marker"
      aria-label={message}
      title={message}
      className={cn(
        'inline-flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border text-[9px] font-bold leading-none',
        estimated
          ? 'border-amber-500/70 bg-amber-500/10 text-amber-400'
          : 'border-amber-500 bg-amber-500/20 text-amber-300',
        className,
      )}
    >
      {estimated ? '~' : '!'}
    </span>
  );
}
